import request2 from "@/utils/request2";
import request from "@/utils/request";

// 代理商登录
export function login(query) {
  return request({
    url: `/auth/login`,
    method: "post",
    data: query,
  });
}
// 验证码
export function getCodeImg() {
  return request({
    url: `/code`,
    method: "get"
  });
}
export function getOperatorSelect(params) {
  return request2({
    url: `/huizhi-charge/operator/getOperatorSelect`,
    method: "get",
    params: params,
  });
}
//订单列表
export function getOrderList(query) {
  return request2({
    url: "/huizhi-charge/sysOrder/getOrderList",
    method: "get",
    params: query,
  });
}

//分成订单列表
export function getDividerOrderList(query) {
  return request2({
    //url: "/huizhi-charge/sysOrder/getDividerOrderList",
    url: "/huizhi-charge/share/config/getShareRecords",
    method: "get",
    params: query,
  });
}
//订单详情
export function getOrderDetails(query) {
  return request2({
    url: "/huizhi-charge/sysOrder/getOrderData",
    method: "get",
    params: query,
  });
}
//订单详情2
export function getOrderDetails2(query) {
  return request2({
    url: "/huizhi-charge/sysOrder/v2/order-detail",
    method: "get",
    params: query,
  });
}
//订单状态追踪
export function getOrderTrack(query) {
  return request2({
    url: "/huizhi-charge/sysOrder/v2/order-trace",
    method: "get",
    params: query,
  });
}
//获取站点列表
export function getPlotList(query) {
  return request2({
    url: "/huizhi-charge/plot/getPlotList",
    method: "get",
    params: query,
  });
}
//获取站点列表(v2，按代理商/区域过滤)
export function getPoltListV2(query) {
  return request2({
    url: "/huizhi-charge/plot/v2/plotList",
    method: "get",
    params: query,
  });
}
//获取站点列表
export function getDividerPlotList(query) {
  return request2({
    url: "/huizhi-charge/plot/getDividerPlotList",
    method: "get",
    params: query,
  });
}
//获取站点列表
export function getShareholdersPlotList(query) {
  return request2({
    url: "/huizhi-charge/shareholdersRatio/getPlotList",
    method: "get",
    params: query,
  });
}
//新增站点
export function addPlot(body) {
  return request2({
    url: "/huizhi-charge/plot/addPlot",
    method: "post",
    data: body,
  });
}

//删除站点
export function deletePlot(query) {
  return request2({
    url: `/huizhi-charge/plot/delPlot?id=${query.id}`,
    method: "delete",
  });
}
//编辑站点
export function editPlot(body) {
  return request2({
    url: `/huizhi-charge/plot/editPlot`,
    method: "post",
    data: body,
  });
}
//获取站点占桩费配置
export function getOccupancyConfig(plotId) {
  return request2({
    url: `/huizhi-charge/occupancy/get/${plotId}`,
    method: "get",
  });
}
//保存站点占桩费配置
export function saveOccupancyConfig(data) {
  return request2({
    url: "/huizhi-charge/occupancy/save",
    method: "post",
    data: data,
  });
}
//设置分成方式（旧模式）
export function setSharingType(data) {
  return request2({
    url: "/huizhi-charge/plot/setSharingType",
    method: "post",
    data: data,
  });
}
//获取分成配置（新模式）
export function getShareConfig(data) {
  return request2({
    url: "/huizhi-charge/share/config",
    method: "get",
    params: data,
  });
}
//更新分成配置（新模式）
export function getShareSaveOrUpdate(data) {
  return request2({
    url: "/huizhi-charge/share/config/saveOrUpdate",
    method: "post",
    data: data,
  });
}
//获取广告列表
export function getAdvertList(query) {
  return request2({
    url: `/huizhi-charge/advert/getAdvertList`,
    method: "get",
    params: query,
  });
}
//新增广告
export function addAdvertList(body) {
  return request2({
    url: `/huizhi-charge/advert/addAdvert`,
    method: "post",
    data: body,
  });
}
//删除广告
export function delAdvert(query) {
  return request2({
    url: `/huizhi-charge/advert/delAdvert`,
    method: "delete",
    params: query,
  });
}
//编辑广告
export function editAdvert(body) {
  return request2({
    url: `/huizhi-charge/advert/edit`,
    method: "put",
    data: body,
  });
}
//获取促销列表
export function getPromotionList(query) {
  return request2({
    url: `/huizhi-charge/promotion/getPromotionList`,
    method: "get",
    params: query,
  });
}
//添加促销
export function addPromotion(body) {
  return request2({
    url: `/huizhi-charge/promotion/addPromotion`,
    method: "post",
    data: body,
  });
}
//更新促销
export function upDatePromotion(body) {
  return request2({
    url: `/huizhi-charge/promotion/updatePromotion`,
    method: "post",
    data: body,
  });
}
//删除促销
export function delPromotion(id) {
  return request2({
    url: `/huizhi-charge/promotion/delPromotion?id=${id}`,
    method: "delete",
  });
}

export function getChargeTotal(data) {
  return request2({
    url: "/huizhi-charge/chargingpile/getChargeTotal",
    method: "post",
    data: data,
  });
}

//新增设备
export function addEquip(body) {
  return request2({
    url: `/huizhi-charge/chargingpile/addPile`,
    method: "post",
    data: body,
  });
}
//编辑设备
export function editPile(body) {
  return request2({
    url: `/huizhi-charge/chargingpile/editPile`,
    method: "post",
    data: body,
  });
}
//根据名称查询供应商
export function searchEquipmentSupply(query) {
  return request2({
    url: `/huizhi-charge/equipmentSupply/getList`,
    method: "get",
    params: query,
  });
}
//获取协议列表
export function getProtocolTypeList(query) {
  return request2({
    url: `/huizhi-charge/getCodesByParent`,
    method: "get",
    params: query,
  });
}

//获取设备列表
export function getEquipList(query) {
  return request2({
    url: `/huizhi-charge/chargingpile/getChargingPileList`,
    method: "get",
    params: query,
  });
}
//获取菜单列表
export function getMenuList(data) {
  return request2({
    url: `/huizhi-charge/menu/getMenuList`,
    method: "get",
    params: data,
  });
}

//获取用户数据列表
export function getUserList(data) {
  return request2({
    url: `/huizhi-charge/registerUser/getRegisterUser`,
    method: "get",
    params: data,
  });
}
// 获取用户充值记录
export function getUserChongzhi(data) {
  return request2({
    url: `/huizhi-charge/registerUser/getRechargeRecods`,
    method: "get",
    params: data,
  });
}

// 获取卡列表
export function getCardList(data) {
  return request2({
    url: `/huizhi-charge/sysCard/getCardList`,
    method: "get",
    params: data,
  });
}
//查询注册用户下所有的未挂失的卡
export function getCardListByCustomerId(data) {
  return request2({
    url: `/huizhi-charge/sysCard/getCardListByCustomerId`,
    method: "get",
    params: data,
  });
}
// 转账
export function transferAccounts(body) {
  return request2({
    url: `/huizhi-charge/sysCard/transferAccounts`,
    method: "post",
    params: body,
  });
}

// 挂失卡
export function lossCard(query) {
  return request2({
    url: `/huizhi-charge/sysCard/lossCard`,
    method: "get",
    params: query,
  });
}
// 取消挂失
export function cancelLoss(query) {
  return request2({
    url: `/huizhi-charge/sysCard/cancelLoss`,
    method: "get",
    params: query,
  });
}
// 卡充值
export function chongzhiCard(data) {
  return request2({
    url: `/huizhi-charge/sysCard/rechargeCard`,
    method: "post",
    params: data,
  });
}
// 解绑用户
export function cancelBind(query) {
  return request2({
    url: `/huizhi-charge/sysCard/cancelBind`,
    method: "get",
    params: query,
  });
}
// 补卡
export function cardFeplacement(data) {
  return request2({
    url: `/huizhi-charge/card/cardFeplacement`,
    method: "post",
    data: data,
  });
}
// 删除卡
export function delCards(data) {
  return request2({
    url: `/huizhi-charge/sysCard/delCards`,
    method: "delete",
    params: data,
  });
}
// 新增卡
export function addCard(data) {
  return request2({
    url: `/huizhi-charge/sysCard/addCard`,
    method: "post",
    data: data,
  });
}
// 编辑卡
export function editCard(body) {
  return request2({
    url: `/huizhi-charge/sysCard/editCard`,
    method: "post",
    data: body,
  });
}
// 卡充值记录
export function getRechargeRecods(query) {
  return request2({
    url: `/huizhi-charge/card/getRechargeRecods`,
    method: "get",
    params: query,
  });
}
// 卡使用记录
export function getUseRecods(query) {
  return request2({
    url: `/huizhi-charge/sysCard/getUseRecods`,
    method: "get",
    params: query,
  });
}
// 用户余额
export function getMyData(query) {
  return request2({
    url: `/huizhi-charge/my/getMyData`,
    method: "get",
    params: query,
  });
}
//绑定提现wxGET
export function bindWx(code) {
  return request2({ url: `/huizhi-charge/my/bindWx?code=${code}`, method: "get" });
}
//获取用户提现记录列表
export function getCashRecord(params) {
  return request2({
    url: `/huizhi-charge/my/getCashRecord`,
    method: "get",
    params,
  });
}
// 获取用户信息
export function getUserInfo(query) {
  return request2({
    url: `/huizhi-charge/registerUser/userInfo`,
    method: "get",
    params: query,
  });
}
// 获取今日收益
export function getDayProfit(query) {
  return request2({
    url: `/huizhi-charge/management/getDayProfit`,
    method: "get",
    params: query,
  });
}
// 发送验证码
export function sendMsg(query) {
  return request2({
    url: `/huizhi-charge/my/sendMsg`,
    method: "get",
    params: query,
  });
}
// 提现
export function cashWithdrawal(query) {
  return request2({
    url: `/huizhi-charge/my/cashWithdrawal`,
    method: "get",
    params: query,
  });
}

// 获取规则时段
export function getRulePriceList(query) {
  return request2({
    url: "/huizhi-charge/rule/getRulePriceList",
    method: "get",
    params: query,
  });
}
// 获取规则列表
export function getRuleList(data) {
  return request2({
    url: "/huizhi-charge/sysRule/getRuleList",
    method: "get",
    params: data,
  });
}
// 编辑规则
export function editRule(data) {
  return request2({
    url: "/huizhi-charge/sysRule/v2/editRule",
    method: "post",
    data: data,
  });
}
// 新增规则
export function addRule(data) {
  return request2({
    url: "/huizhi-charge/sysRule/v2/addRule",
    method: "post",
    data: data,
  });
}
// 删除规则
export function deleteRule(data) {
  return request2({
    url: "/huizhi-charge/sysRule/deleteRule",
    method: "delete",
    params: data,
  });
}
// 问题反馈列表
export function getFeedBackList(data) {
  return request2({
    url: "/huizhi-charge/sysFeedback/getFeedBackList",
    method: "get",
    params: data,
  });
}
// 获取端口列表
export function getPortList(data) {
  return request2({
    url: "/huizhi-charge/port/getPortList",
    method: "get",
    params: data,
  });
}
//设置充电桩规则
export function setPileRule(data) {
  return request2({
    url: "/huizhi-charge/chargingpile/setPileRule",
    method: "get",
    params: data,
  });
}
// 开启关闭端口
export function switchPort(data) {
  return request2({
    url: "/huizhi-charge/port/switchPort",
    method: "post",
    params: data,
  });
}
export function editPort(data) {
  return request2({
    url: "/huizhi-charge/port/editPort",
    method: "post",
    data: data,
  });
}
//订单退款
export function refundOrder(data) {
  return request2({
    url: "/huizhi-charge/sysOrder/refundOrder",
    method: "get",
    params: data,
  });
}
// 复制规则
export function copyRule(data) {
  return request2({
    url: "/huizhi-charge/sysRule/copyRule",
    method: "get",
    params: data,
  });
}
// 密码修改
export function changePwd(data) {
  return request2({
    url: "/huizhi-charge/changePwd",
    method: "post",
    data: data,
  });
}
// 登出
export function loginOut() {
  return request2({
    url: "/huizhi-charge/loginOut",
    method: "post"
  });
}
//订单状态跟踪
export function orderTrace(data) {
  return request2({
    url: "/huizhi-charge/sysOrder/v2/order-trace",
    method: "get",
    params: data,
  });
}
// 问题反馈详情
export function getFeedBack(data) {
  return request2({
    url: "/huizhi-charge/sysFeedback/getFeedBack",
    method: "post",
    params: data,
  });
}
// 问题处理
export function doFeedBack(data) {
  return request2({
    url: "/huizhi-charge/sysFeedback/doFeedBack",
    method: "get",
    params: data,
  });
}
// 充电桩收益
export function getSalesDetailByParams(data) {
  return request2({
    url: "/huizhi-charge/management/getSalesDetailByParams",
    method: "get",
    params: data,
  });
}

export function getInfoByKey(data) {
  return request2({
    url: "/huizhi-charge/sysConfig/getInfoByKey",
    method: "get",
    params: data,
  });
}
export function queryAllById(data) {
  return request2({
    url: "/huizhi-charge/webConfig/queryAllById",
    method: "get",
    params: data,
  });
}

export function queryNewsByNewsConfigKey(data) {
  return request2({
    url: "/huizhi-charge/sysNews/queryNewsByNewsConfigKey",
    method: "post",
    params: data,
  });
}

//本月收益
export function getMonProfit() {
  return request2({
    url: "/huizhi-charge/management/getMonProfit",
    method: "get",
  });
}

//分成者收益
export function getDividerProfit(params) {
  return request2({
    url: "/huizhi-charge/management/getDividerProfit",
    method: "get",
    params: params
  });
}

//分成者经营数据
export function getDividerManageData(params) {
  return request2({
    url: "/huizhi-charge/management/getDividerManageData",
    method: "post",
    data: params
  });
}
//分成者经营数据
export function getOperateData(params) {
  return request2({
    url: "/huizhi-charge/management/getOperateData",
    method: "post",
    data: params
  });
}

export function getMapGeocoder(params) {
  return request2({
    url: "/huizhi-charge/qq/map/geocoder",
    method: "get",
    params: params,
  });
}

export function getMapSuggestion(params) {
  return request2({
    url: "/huizhi-charge/qq/map/suggestion",
    method: "get",
    params: params,
  });
}

/** Google 地图 - 逆地理编码 */
export function getGoogleMapGeocoder(params) {
  return request({
    // baseURL: "",
    url: "/huizhi-charge-api/google/map/geocoder",
    method: "get",
    params,
  });
}

/** Google 地图 - 区域关键词搜索 */
export function getGoogleMapSearchArea(params) {
  return request({
    // baseURL: "",
    url: "/huizhi-charge-api/google/map/searchArea",
    method: "get",
    params,
  });
}



// 编辑二轮规则
export function editTwoRule(data) {
  return request2({
    url: "/huizhi-charge/sysRule/two/editTwoRule",
    method: "post",
    data: data,
  });
}
// 两轮计费规则新增
export function addTwoRule(data) {
  return request({
    url: '/huizhi-charge/sysRule/two/addTwoRule',
    method: 'post',
    data
  })
}

// 根据id查询二轮规则详情
export function getTwoRuleById(data) {
  return request2({
    url: "/huizhi-charge/sysRule/two/twoRuleList?id=" + data.id,
    method: "post",
    data: data,
  });
}



//获取账户详情
export function showaccount(params) {
  return request2({
    url: '/huizhi-charge/withdraworder/myAccount',
    method: 'get',
    params,
  });
}

//确认提现
export function applywithdraw(data) {
  return request2({
    url: '/huizhi-charge/trade/withdraw',
    method: 'post',
    data,
  });
}

//获取提现列表
export function withdrawindex(params) {
  return request2({
    url: '/huizhi-charge/sysOrder/withdraworder/getOrderList',
    method: 'get',
    params,
  });
}

//上传文件
export function uploadInvoiceApi(data) {
  return request2({
    url: '/huizhi-charge/file/uploadImg',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}


//分成者查看分账明细
export function shareOrderGetList(params) {
  return request2({
    url: '/sysOrder/shareOrder/getOrderList',
    method: 'get',
    params,
  });
}


//清分代理商分成明细
export function getCommissionRecordListForOperator(params) {
  return request2({
    url: '/operatorCommissionRecord/getCommissionRecordListForOperator',
    method: 'get',
    params,
  });
}


//订单分成者分成明细
export function getShareholderRoyaltyResultList(params) {
  return request2({
    url: '/operatorCommissionRecord/getShareholderRoyaltyResultList',
    method: 'get',
    params,
  });
}


//分成者管理列表
export function getShareholderList(params) {
  return request2({
    url: '/v2/shareholders/action/page',
    method: 'get',
    params,
  });
}


// 获取分成汇总数据
export function getRoyaltySummary(params) {
  return request2({
    url: "/huizhi-charge/royalty/getRoyaltySummary",
    method: "get",
    params: params,
  });
}

// 获取代理商、分成者的站点列表
export function getPlotListForOperator(query) {
  return request2({
    url: "/huizhi-charge/royalty/getPlotList",
    method: "get",
    params: query,
  });
}


//通过规则Id获取规则的充电档位数据
export function getRuleSlot(data) {
    return request2({
        url: '/huizhi-charge/sysRule/getRuleSlot',
        method: 'get',
        params: data
    })
}

export function getManageTotalData(data) {
  return request({
    url: '/huizhi-charge/Statistics/getManageTotalData',
    method: 'post',
    data: data

  })
}

export function getShareTotalAmount(params) {
  return request({
    url: '/huizhi-charge/management/getShareTotalAmount',
    method: "get",
    params: params

  })
}

// 省列表
export function getProvinceList(params) {
  return request2({
    url: "/huizhi-charge/city/getProvinceList",
    method: "get",
    params: params,
  });
}

// 市/区列表（pid 为上级 id）
export function getCityList(params) {
  return request2({
    url: "/huizhi-charge/city/getCityList",
    method: "get",
    params: params,
  });
}
